module.exports = __webpack_public_path__ + "img/img118.6b6980ca.svg";